if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          // Clau 9 oct 2026 (velocidad): con el cajon de la cesta solo se pide el numero del icono;
          // la cesta completa se repinta despues en segundo plano (lafCart.refresh).
          const lafLigero = !!(window.lafCart && window.lafCart.refresh && this.cart.tagName === 'CART-DRAWER');
          formData.append(
            'sections',
            lafLigero ? 'cart-icon-bubble' : this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.renderCartSilently(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.renderCartSilently(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      // LaFarmacia: al anadir desde la ficha la cesta NO se abre sola; se
      // actualiza en segundo plano y aparece el mismo aviso que en el
      // buscador (laf-cart.js). La cesta se abre al tocar el icono del carrito.
      renderCartSilently(response) {
        this.lafNoAbrir();
        const lafCart = window.lafCart;
        if (lafCart && lafCart.applySections && this.cart && this.cart.tagName === 'CART-DRAWER' && response.sections) {
          lafCart.applySections(response.sections);
          lafCart.toast('Añadido a la cesta');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          this.lafCount();
          if (lafCart.refresh) lafCart.refresh();
          return;
        }
        // Clau 9 oct 2026: con la cesta propia de la tienda (cart-notification + #cartDrawer de
        // custom.js) tampoco sale la ventana "Articulo agregado / Ver carrito / Seguir comprando":
        // se actualiza la cesta y el contador y aparece el aviso naranja "Añadido a la cesta".
        if (this.cart && this.cart.tagName === 'CART-NOTIFICATION') {
          fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
            .then((r) => r.json())
            .then((cart) => {
              this.lafCount(cart);
              try { if (typeof window.renderCartDrawer === 'function') window.renderCartDrawer(cart); } catch (e) { console.warn(e); }
            })
            .catch(() => {});
          this.lafToast('Añadido a la cesta');
          return;
        }
        this.cart.renderContents(response);
      }

      // Clau 9 oct 2026: el numero del icono del carrito sube al momento, tambien en el movil
      // (se actualizan TODOS los iconos de carrito de la pagina, el de escritorio y el del movil).
      lafCount(cart) {
        const pinta = (n) => {
          const iconos = document.querySelectorAll('#cart-icon-bubble, a.header__icon--cart, a[href$="/cart"].header__icon');
          iconos.forEach((ic) => {
            let b = ic.querySelector('.cart-count-bubble');
            if (!b && n > 0) {
              b = document.createElement('div');
              b.className = 'cart-count-bubble';
              b.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
              ic.appendChild(b);
            }
            if (!b) return;
            const vis = b.querySelector('span[aria-hidden]') || b;
            vis.textContent = n;
            const hid = b.querySelector('.visually-hidden');
            if (hid) hid.textContent = n + (n === 1 ? ' artículo' : ' artículos');
            b.style.display = n > 0 ? '' : 'none';
            b.classList.remove('hidden');
          });
          document.querySelectorAll('.count_cart').forEach((el) => { el.textContent = n; });
        };
        if (cart && typeof cart.item_count === 'number') { pinta(cart.item_count); return; }
        fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((c) => pinta(c.item_count))
          .catch(() => {});
      }

      // Clau 9 oct 2026: al anadir, la cesta NO se abre nunca (ni la lateral propia, ni la ventana
      // de Shopify, ni el cajon de Dawn). Durante 1,5 segundos, si algo la abre, se vuelve a cerrar.
      lafNoAbrir() {
        const cerrar = () => {
          const d = document.getElementById('cartDrawer');
          if (d && d.classList.contains('open')) {
            d.classList.remove('open');
            const bd = document.querySelector('.ea-sticky-cart-backdrop');
            if (bd) bd.classList.remove('open');
          }
          const n = document.querySelector('cart-notification');
          const nn = n && n.querySelector('#cart-notification');
          if (nn && nn.classList.contains('active')) nn.classList.remove('active', 'animate');
          const cd = document.querySelector('cart-drawer');
          if (cd && cd.classList.contains('active') && typeof cd.close === 'function') cd.close();
        };
        const fin = Date.now() + 1500;
        const tick = () => { cerrar(); if (Date.now() < fin) requestAnimationFrame(tick); };
        tick();
      }

      lafToast(msg) {
        let t = document.getElementById('laf-toast');
        if (!t) {
          t = document.createElement('div');
          t.id = 'laf-toast';
          t.className = 'laf-toast';
          t.setAttribute('role', 'status');
          t.setAttribute('aria-live', 'polite');
          document.body.appendChild(t);
        }
        t.textContent = msg;
        t.classList.remove('laf-toast--err');
        t.classList.add('show');
        clearTimeout(t._h);
        t._h = setTimeout(() => t.classList.remove('show'), 2200);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
